// import { io } from "socket.io-client";

// let socket = null;

// export const connectSocket = () => {
//   if (!socket) {
//     const token = localStorage.getItem("token");

//     socket = io("http://localhost:4000", {
//       transports: ["websocket"],
//       withCredentials: true,

//       // ✅ SEND TOKEN HERE
//       auth: {
//         token,
//       },
//     });

//     socket.on("connect", () => {
//       console.log("🟢 Socket connected:", socket.id);
//     });

//     socket.on("connect_error", (err) => {
//       console.error("❌ Socket connect error:", err.message);
//     });
//   }

//   return socket;
// };

// export const getSocket = () => socket;

// export const disconnectSocket = () => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//     console.log("🔴 Socket disconnected");
//   }
// };
import { io } from "socket.io-client";
export const getSocket = () => socket;

let socket = null;
let isRefreshing = false;

const API_URL =
  import.meta.env.VITE_API_URL || "https://crm.backend.thefither.com";

export const connectSocket = () => {
  if (!socket) {
    const token = localStorage.getItem("token");

    socket = io(API_URL, {
      transports: ["websocket"],
      withCredentials: true,
      auth: { token },
    });

    socket.on("connect", () => {
      console.log("🟢 Socket connected:", socket.id);
    });

    socket.on("connect_error", async (err) => {
      console.error("❌ Socket connect error:", err.message);

      if (isRefreshing) return;
      if (!err.message.includes("jwt") && err.message !== "Unauthorized") return;

      isRefreshing = true;

      try {
        const res = await fetch(`${API_URL}/auth/refresh`, {
          method: "POST",
          credentials: "include",
        });

        if (!res.ok) throw new Error("Refresh failed");

        const data = await res.json();
        if (!data.token) throw new Error("No token");

        localStorage.setItem("token", data.token);
        socket.auth = { token: data.token };

        socket.disconnect();
        socket.connect();
      } catch {
        localStorage.removeItem("token");
        disconnectSocket();
        window.location.href = "/";
      } finally {
        isRefreshing = false;
      }
    });
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("🔴 Socket disconnected");
  }
};
